export default "__VITE_ASSET__KKs7n2nQ__"